import * as i0 from "@angular/core";
var ExampleService = /** @class */ (function () {
    function ExampleService() {
    }
    ExampleService.ngInjectableDef = i0.defineInjectable({ factory: function ExampleService_Factory() { return new ExampleService(); }, token: ExampleService, providedIn: "root" });
    return ExampleService;
}());
export { ExampleService };
